import React from 'react';
import { Button, Form, Header, Icon, Input, Label, Loader, Popup, Table } from 'semantic-ui-react';
import axios from 'axios';
import { FiltersOnStyle } from '../../Professor/ProfessorInputGrades/css';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class CoursesTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            courseImplementationName: localStorage.getItem('courseImplementationNameFilter') ? localStorage.getItem('courseImplementationNameFilter') : '',
            filterData: [],
            academicYears: [],
            academicYear: parseInt(localStorage.getItem('academicYear'), 10) ? parseInt(localStorage.getItem('academicYear'), 10) : this.props.currentAcademicYear,
            activeIndex: 0
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.setThirdCycle = this.setThirdCycle.bind(this);
        this.getSemesters = this.getSemesters.bind(this);
        this.getAcademicYears = this.getAcademicYears.bind(this);
        this.setSpecialist = this.setSpecialist.bind(this);
    }

    componentWillMount() {
        if (localStorage.getItem('returned')) {
            localStorage.removeItem('returned');
            this.getAcademicYears();
            this.getSemesters(this.state.academicYear);
            this.setState({
                data: this.props.data,
                // data: JSON.parse(localStorage.getItem('filterData')),
                filterData: localStorage.getItem('filterData') ? JSON.parse(localStorage.getItem('filterData')) : [],
                semester: parseInt(localStorage.getItem('semester'), 10),
                courseImplementationName: localStorage.getItem('courseImplementationNameFilter')
            });
        } else {
            this.getAcademicYears();
            axios.get('/academic-years/current-and-previous/')
                .then(res => {
                    this.setState({
                        academicYears: res.data.map(el => ({
                            ...el, key: el.id, value: el.id, text: el.name
                        })).reverse(),
                        academicYear: parseInt(localStorage.getItem('academicYear'), 10)
                            ? parseInt(localStorage.getItem('academicYear'), 10)
                            : parseInt(localStorage.getItem('currentAcademicYear'), 10)
                    });
                    // this.props.getCoursesByAcademicYear(parseInt(localStorage.getItem('academicYear'), 10));
                    this.getSemesters(parseInt(localStorage.getItem('academicYear'), 10)
                        ? parseInt(localStorage.getItem('academicYear'), 10)
                        : parseInt(localStorage.getItem('currentAcademicYear'), 10));
                });
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.data !== prevProps.data) {
            this.setState({ data: this.props.data });
        }
    }


    getSemesters(academicYearId) {
        axios.get(`semester/by-academic-year/${academicYearId}`)
            .then(res => {
                this.setState({
                    semesterOptions: res.data.filter(e => e.name.name !== 'ostalo').map(el => ({
                        ...el, key: el.id, value: el.id, text: el.name.name + ' ' + el.academicYear.name
                    }))
                });
            });
    }

    getAcademicYears() {
        axios.get('/academic-years/current-and-previous/')
            .then(res => {
                this.setState({
                    academicYears: res.data.map(el => ({
                        ...el, key: el.id, value: el.id, text: el.name
                    })).reverse()
                });
            });
    }

    setThirdCycle(courseBasicId) {
        axios.get(`course/third-cycle-check/${courseBasicId}/`)
            .then(res => {
                if (res.data) {
                    localStorage.setItem('thirdCycle', true);
                } else {
                    localStorage.setItem('thirdCycle', false);
                }
            }).then(() => {
                this.props.showExamDetails();
            });
    }

    setSpecialist(courseBasicId) {
        axios.get(`course/specialist-study-program-check/${courseBasicId}/`)
            .then(res => {
                if (res.data) {
                    localStorage.setItem('specialist', true);
                } else {
                    localStorage.setItem('specialist', false);
                }
            }).then(() => {
                this.props.showExamDetails();
            });
    }

    handleTabChange(e, { activeIndex }) {
        this.setState({ activeIndex });
        localStorage.setItem('activeIndexSemester', activeIndex);
    }


    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });


        if (name === 'academicYear') {
            this.setState({ semester: null, courseImplementationName: '', filterData: [] });
            localStorage.setItem('academicYear', value);
            localStorage.removeItem('semester');
            localStorage.removeItem('courseImplementationNameFilter');
            localStorage.removeItem('filterData');
            this.props.getCoursesByAcademicYear(value);
            this.getSemesters(value);
        } else {
            let filterDoc = {
                semester: this.state.semester,
                courseImplementationName: this.state.courseImplementationName
            };
            if (name === 'semester') {
                filterDoc = { ...filterDoc, semester: value };
                localStorage.setItem('semester', value);
            }
            if (name === 'courseImplementationName') {
                filterDoc = { ...filterDoc, courseImplementationName: value };
                localStorage.setItem('courseImplementationNameFilter', value);
            }
            this.setFilterData(filterDoc);
        }
    }

    setFilterData(filterDoc) {
        let filterData = this.state.data.filter((e) => {
            if (filterDoc.semester && filterDoc.courseImplementationName) {
                return e.semesters[0].id === filterDoc.semester && e.courseBasic.name.toLowerCase().match(filterDoc.courseImplementationName.toLowerCase());
            } else if (filterDoc.semester) {
                return e.semesters[0].id === filterDoc.semester;
            } else if (filterDoc.courseImplementationName) {
                return e.courseBasic.name.toLowerCase().match(filterDoc.courseImplementationName.toLowerCase());
            }
        });
        localStorage.setItem('filterData', JSON.stringify(filterData));
        this.setState({
            filterData

        });
    }

    getCoursesByCourseImplementationName(getCoursesByCourseImplementationName) {
        this.setState({
            filterData: this.state.filterData.length === 0 ?
                this.state.data.filter((e) => (e.courseBasic.name.toLowerCase().match(getCoursesByCourseImplementationName.toLowerCase()))) :
                this.state.filterData.filter((e) => (e.courseBasic.name.toLowerCase().match(getCoursesByCourseImplementationName.toLowerCase())))
        });
    }

    render() {
        return (
            <div>
                <Form>
                    <Form.Group widths="equal">
                        <Form.Field>
                            <label>Akademska godina</label>
                            <Form.Dropdown
                                placeholder="Odaberite akademsku godinu"
                                value={this.state.academicYear}
                                onChange={this.handleInputChange}
                                name="academicYear"
                                options={this.state.academicYears}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>Semestar</label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odaberite semestar"
                                value={this.state.semester}
                                onChange={this.handleInputChange}
                                name="semester"
                                options={this.state.semesterOptions}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        <Form.Field
                            control={Input}
                            value={this.state.courseImplementationName}
                            label="Naziv predmeta"
                            onChange={this.handleInputChange}
                            name="courseImplementationName"
                            placeholder="Unesite naziv predmeta"

                        />
                    </Form.Group>
                </Form>
                <br />

                {this.props.loader ?
                    <div style={{ paddingTop: '20px', paddingBottom: '20px' }}><Loader active inline="centered" /></div>
                    : <CourseSemesterTable
                        data={this.state.filterData.length !== 0 ? this.state.filterData : this.state.data}
                        setThirdCycle={this.setThirdCycle}
                        setSpecialist={this.setSpecialist}
                        previous={this.state.academicYear !== this.props.currentAcademicYear}
                    />}

            </div>);
    }
}


const CourseSemesterTable = ({
    data, previous, setThirdCycle, setSpecialist
}) => (
    <div>{ data.length ? <Table celled selectable compact>
        <Table.Header>
            <Table.Row>
                <Table.HeaderCell width={1}>R. br.</Table.HeaderCell>
                <Table.HeaderCell colSpan="3">
                    <Header as="h4">
                        <Header.Content>
                            Predmet
                        </Header.Content>
                    </Header>
                </Table.HeaderCell>
                <Table.HeaderCell colSpan="2">
                    <Header as="h4">
                        <Header.Content>
                            Napomena
                            <Header.Subheader>Predmet / implementacija</Header.Subheader>
                        </Header.Content>
                    </Header>
                </Table.HeaderCell>

                <Table.HeaderCell colSpan={2} />
            </Table.Row>
        </Table.Header>
        <Table.Body> {data.map((el, index) =>
            (<Table.Row key={el.id}>
                <Table.Cell verticalAlign="middle">
                    {index + 1}.
                </Table.Cell>
                <Table.Cell verticalAlign="middle" colSpan="3">
                    <span >  {el.semesters[0].name._key === 'winter semester' ? <Icon name="snowflake" color="blue" /> : <Icon name="sun" color="yellow" />}{el.code ? el.courseBasic.name + ' | ' + el.code : el.courseBasic.name}</span>

                </Table.Cell>
                <Table.Cell verticalAlign="middle" colSpan="2">
                    <span>
                        {el.courseBasic.comment && <Popup content="Predmet" hideOnScroll position="top center" trigger={<Label as="a" basic><Icon name="comment alternate outline" /> {el.courseBasic.comment}</Label>} />}
                        {el.comment && <Popup content="Implementacija" hideOnScroll position="top center" trigger={<Label as="a" basic><Icon name="comment alternate outline" /> {el.comment}</Label>} />}
                        {el.collisionApproved && <Label as="a" basic><Icon name="random" />Kolizija</Label>}
                    </span>


                </Table.Cell>
                <Table.Cell textAlign="center" verticalAlign="middle" colSpan={2}>
                    <Button
                        style={FiltersOnStyle}
                        icon
                        labelPosition="right"
                        size="medium"
                        color="blue"
                        basic
                        onClick={() => {
                            localStorage.removeItem('thirdCycle');
                            localStorage.removeItem('specialist');
                            setThirdCycle(el.courseBasic.id);
                            setSpecialist(el.courseBasic.id);
                            localStorage.setItem('previous', previous);
                            localStorage.setItem('id', el.id);
                            localStorage.setItem('name', el.courseBasic.name);
                            localStorage.setItem('comment', el.courseBasic.comment);
                        }}
                    > <Icon name="copy outline" />Kreiranje i prikaz ispita</Button>
                </Table.Cell>
            </Table.Row>))}
        </Table.Body>
    </Table> : <div><br />Nema predmeta u ovom semestru.<br /></div>}
    </div>);



// WEBPACK FOOTER //
// ./src/views/StudentService/Exams/CoursesTable.js